import { useMemo } from "react";
import useZipCodesHook from "./useZipCodesHook";
import { asArray, findZipcode } from "../utils/helpers";

const useFindAreasHook = (zipcode: string) => {
  const { query } = useZipCodesHook();
  const zipcodes = useMemo(
    () => (query.isSuccess ? findZipcode(zipcode, query.data) : []),
    [zipcode, query]
  );

  let retVal = [];
  zipcodes.forEach((zipcode) => {
    retVal = [...retVal, ...asArray(zipcode.area)];
  });

  return retVal;
};

export default useFindAreasHook;
